<mat-sidenav-container>
    <div class="login-container">
        <div class="center-content">
            <mat-card class="w-px-300">
                <mat-card-header>
                    <div class="logo-container">
                        <img *ngIf="dark" [src]="'../assets/images/cristie_trans.png'" alt="Cristie Logo" id="logo" />
                        <img *ngIf="!dark" [src]="'../assets/images/cristiesw.png'" alt="Cristie Logo" id="logo" />
                    </div>
                </mat-card-header>
                <mat-card-content *ngIf="loading">
                    <div class="page-loading-spinner">
                        <mat-spinner color="primary" [diameter]="100"></mat-spinner>
                    </div>
                </mat-card-content>
                <mat-card-content *ngIf="!loading">
                    <div class="notice" *ngIf="showPendingMaint">
                        <div class="notice-body">{{ maint?.message }}</div>
                    </div>
                    <div class="notice notice-error" *ngIf="showActiveMaint">
                        <div class="notice-body">{{ maint?.message }}</div>
                    </div>
                    <form class="login-form" (ngSubmit)="submitLogin()">
                        <mat-form-field class="w-100">
                            <mat-label>Username</mat-label>
                            <input matInput id="username-input" [(ngModel)]="username" [ngModelOptions]="{standalone: true}" required/>
                            <mat-hint align="start">Email or trial username</mat-hint>
                        </mat-form-field>

                        <app-password-input inputId="password-input" label="Password" [(password)]="password" required></app-password-input>
                        <button type="submit" hidden aria-hidden="true"></button>
                    </form>
                </mat-card-content>
                <mat-card-actions class="flex-column">
                    <ng-container  *ngIf="!loading">
                        <div class="display-flex w-100">
                            <button mat-stroked-button color="secondary" id="reset-password-button" (click)="resetPassword()">Reset Password</button>
                            <div class="spacer"></div>
                            <button mat-raised-button color="primary" id="login-button" class="login-button" [disabled]="!username || !password || loggingIn || showActiveMaint" (click)="submitLogin()">Login</button>
                        </div>
                        <ng-container>
                            <div class="login-divider">
                                <span>Or</span>
                            </div>
                            <button mat-stroked-button color="secondary" id="register-button" class="w-100 mgt-10" (click)="register()">
                                <mat-icon>add</mat-icon>
                                Register
                            </button> 
                        </ng-container>
                    </ng-container>
                </mat-card-actions>
                <mat-card-footer>
                    <p class="text-center m-0 pdb-5" *ngIf="loggingIn && status">{{status}}</p>
                    <mat-progress-bar *ngIf="loggingIn" mode="indeterminate"></mat-progress-bar>
                </mat-card-footer>
            </mat-card>
        </div>
    </div>
</mat-sidenav-container>
